var map = {
	"./about/1.jpg": 3512,
	"./about/2.jpg": 8263,
	"./about/img (2).jpg": 9295,
	"./about/img-1 (2).jpg": 9337,
	"./about/img-1.jpg": 3462,
	"./about/img-2 (2).jpg": 1986,
	"./about/img-2.jpg": 5601,
	"./about/img-3 (2).jpg": 4395,
	"./about/img-3.jpg": 2004,
	"./about/img.jpg": 6904,
	"./about/shape-2.png": 307,
	"./about/shape.png": 4954,
	"./about/somalia-somaliland.jpg": 4528,
	"./cta/like 3.png": 6916,
	"./cta/shape-1.png": 8365,
	"./cta/shape-2.png": 950,
	"./cta/top-icon.png": 2719,
	"./dahabshiil.jpg": 4032,
	"./dahabshiil3.png": 8805,
	"./dara.jpg": 3141,
	"./darasalaam2.png": 2034,
	"./default donate.jpg": 7359,
	"./dh.png": 383,
	"./ds.png": 6268,
	"./edahab.jpg": 8542,
	"./edahab.png": 6314,
	"./error-404.png": 6301,
	"./evc.png": 5339,
	"./footer-bg.jpg": 6963,
	"./img.jpg": 7986,
	"./logo2.png": 4662,
	"./logo3.png": 3679,
	"./master.jpg": 8361,
	"./partners/DRC.webp": 6660,
	"./partners/IOM.jpg": 7106,
	"./partners/care.png": 2396,
	"./paystack.png": 6041,
	"./sahal.png": 8420,
	"./salaam_bank.png": 4563,
	"./salaam_somali_bank.png": 9583,
	"./sb.png": 2504,
	"./select-icon.png": 5633,
	"./select-icon2.png": 8519,
	"./service-single/1.png": 8925,
	"./service-single/2.png": 7302,
	"./service-single/3.png": 3631,
	"./service-single/4.png": 2304,
	"./service-single/c1.png": 4566,
	"./service-single/d1.png": 3019,
	"./service-single/d2.png": 4336,
	"./service-single/d3.png": 9161,
	"./service-single/p1.png": 1943,
	"./service-single/p2.png": 1884,
	"./service-single/p3.png": 981,
	"./service/1.png": 6838,
	"./service/1.svg": 9310,
	"./service/2.png": 8077,
	"./service/2.svg": 2285,
	"./service/3.png": 6948,
	"./service/3.svg": 1276,
	"./service/4.png": 2859,
	"./service/4.svg": 7491,
	"./slider/1.png": 2036,
	"./slider/2.png": 9532,
	"./slider/3.png": 5606,
	"./slider/4.jpg": 8657,
	"./slider/5.jpg": 4324,
	"./slider/6.jpg": 4035,
	"./slider/7.jpg": 902,
	"./slider/8.jpg": 7445,
	"./slider/9.jpg": 9576,
	"./ssb.png": 8439,
	"./step2.png": 8867,
	"./step3.png": 3658,
	"./tel.jpg": 3288,
	"./visa.jpg": 4496,
	"./zaad.png": 291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;